// extracted by mini-css-extract-plugin
export default {"lead":"Lead_lead__QS9UK","title":"Lead_title__4Q2tc","body":"Lead_body__WVG6k"};